enum CardInstructionsVariantEnum {
	SMALL = 'small',
	MEDIUM = 'medium',
}

type CardInstructionsTypes = {
	variant?: CardInstructionsVariantEnum;
	title?: string;
	hideDescription?: boolean;
};

type StyledCardInstructionsTypes = {
	$variant?: CardInstructionsVariantEnum;
};

export {CardInstructionsVariantEnum};
export type {CardInstructionsTypes, StyledCardInstructionsTypes};
